import {
  type MarcaListItem,
  type MarcaRequest,
  type MarcaResponse,
  type ModeloListItem,
  type ModeloRequest,
  type ModeloResponse
} from '../types/marca';
import { http } from '../../../../api/http';

export class MarcaService {
  private static readonly ENDPOINTS = {
    MARCAS: '/Articulo/marcas',
    MODELOS: '/Articulo/modelos',
  };

  // Marcas endpoints
  static async getMarcas(): Promise<MarcaListItem[]> {
    try {
      const response = await http.get(this.ENDPOINTS.MARCAS);
      return response.data;
    } catch (error) {
      console.error('Error fetching marcas:', error);
      throw error;
    }
  }

  static async getMarcaById(idMarca: number): Promise<MarcaResponse> {
    try {
      const response = await http.get(`${this.ENDPOINTS.MARCAS}/${idMarca}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching marca by id:', error);
      throw error;
    }
  }

  static async saveMarca(marca: MarcaRequest): Promise<MarcaResponse> {
    try {
      const isUpdate = !!marca.idMarca;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} marca:`, {
        url: this.ENDPOINTS.MARCAS,
        method: 'POST',
        isUpdate,
        data: marca
      });

      const response = await http.post(this.ENDPOINTS.MARCAS, marca);

      console.log(`Marca ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${marca.idMarca ? 'updating' : 'creating'} marca:`, error);
      throw error;
    }
  }

  // Modelos endpoints
  static async getModelos(): Promise<ModeloListItem[]> {
    try {
      const response = await http.get(this.ENDPOINTS.MODELOS);
      return response.data;
    } catch (error) {
      console.error('Error fetching modelos:', error);
      throw error;
    }
  }

  static async getModelosByMarca(idMarca: number): Promise<ModeloListItem[]> {
    try {
      const response = await http.get(`${this.ENDPOINTS.MARCAS}/${idMarca}/modelos`);
      return response.data;
    } catch (error) {
      console.error('Error fetching modelos by marca:', error);
      throw error;
    }
  }

  static async getModeloById(idModelo: number): Promise<ModeloResponse> {
    try {
      const response = await http.get(`${this.ENDPOINTS.MODELOS}/${idModelo}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching modelo by id:', error);
      throw error;
    }
  }

  static async saveModelo(modelo: ModeloRequest): Promise<ModeloResponse> {
    try {
      const isUpdate = !!modelo.idModelo;

      console.log(`${isUpdate ? 'Updating' : 'Creating'} modelo:`, {
        url: this.ENDPOINTS.MODELOS,
        method: 'POST',
        isUpdate,
        data: modelo
      });

      const response = await http.post(this.ENDPOINTS.MODELOS, modelo);

      console.log(`Modelo ${isUpdate ? 'updated' : 'created'} successfully:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`Error ${modelo.idModelo ? 'updating' : 'creating'} modelo:`, error);
      throw error;
    }
  }
}